import React from "react";

const formatCurrency = (amount) => {
  return Number(amount || 0).toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const Row = ({ label, value, bold }) => (
  <div className={`summary-row ${bold ? "summary-total" : ""}`}>
    <div>{label}</div>
    <div>₱ {formatCurrency(value)}</div>
  </div>
);

const InvoiceSummary = ({ invoice }) => {
  return (
    <div className="summary-wrapper">

      <div className="summary-box">

        <Row
          label="Hammer Total"
          value={invoice.hammerTotal}
        />

        <Row
          label="Buyer's Premium"
          value={invoice.buyersPremium}
        />

      
       
      
        <div className="summary-divider"></div>

        <Row
          label="TOTAL"
          value={invoice.grandTotal}
          bold
        />

      </div>

    </div>
  );
};

export default InvoiceSummary;